// application.js
const en = require('json!yaml!././en.yml')
const en2 = require('json!yaml!./en2.yml')
en.en.vue2 = en2

export default en



// WEBPACK FOOTER //
// ./src/i18n/en.js